import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'trigger',
    `
		position: relative;
		min-width: 100px;
	`
  ],
  [
    'uploader',
    `
		position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
    top: 0;
    left: 0;
	`
  ]
]);
